import CreateUserPanel from '@frontend/components/user-access/CreateUserPanel';

export interface ProjectIdentityPanelProps {
  expanded: boolean;
  onToggle: () => void;
}

/**
 * Invite users; assignment limited to managed projects (API enforcement TBD for maintainers).
 * Realm-only create here — ecosystems come from project membership ensureEcosystemMembership.
 */
export default function ProjectIdentityPanel({ expanded, onToggle }: ProjectIdentityPanelProps) {
  return <CreateUserPanel expanded={expanded} onToggle={onToggle} ecosystemAttachMode="none" />;
}
